import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLockGlyphSecondary from './svgs/LockGlyphSecondary.js';
import SvgLockGlyph from './svgs/LockGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lockGlyph = (props => useIcon(SvgLockGlyph, SvgLockGlyphSecondary, props));

export { lockGlyph as default };
